/**
 * Se a pessoa pode alguma coisa -- a pergunta que menu, rota e botao fazem.
 *
 * O nucleo e puro de proposito: quem le o localStorage e `codigosDoUsuario`, e
 * so ela. Assim a regra, que e a parte que erra, da para testar sem navegador.
 *
 * O codigo tem a forma `<ferramenta>:<acao>` -- `accounts.grupos:editar`. Vem
 * pronto do `GET /api/user/{id}/permission`, na chave `codes`, montado pelo
 * PermService a partir de `feature.code` e do nome da acao.
 */

const CHAVE = "permissionsApi";

/**
 * A REGRA DE FALHA, e ela e deliberada: na duvida, LIBERA.
 *
 * `codigos` desconhecido -- nao carregou, deu erro, versao antiga da API sem a
 * chave `codes` -- devolve `true`. Tres razoes:
 *
 *  1. A API confere de verdade. `AuthService::isAuthorized()` monta o caminho
 *     a partir do host e da rota e confere contra a lista do usuario; quem nao
 *     pode toma 403 no endpoint. A tela e conveniencia, nao barreira.
 *  2. Falhar fechado aqui ja trancou a aplicacao uma vez: catalogo vazio ->
 *     arvore vazia -> ninguem e admin -> 403 em tudo -> laco de volta ao admin.
 *  3. Uma tela a mais visivel e incomodo. O app inteiro inacessivel e
 *     incidente.
 *
 * Lista vazia e diferente de desconhecida: `[]` quer dizer "carregou e a pessoa
 * nao tem nada", e ai fecha.
 */
export function pode(codigo, codigos, registrados = null) {
    if (!codigo) {
        return true;
    }

    if (!Array.isArray(codigos)) {
        return true;
    }

    if (codigos.includes("*")) {
        return true;
    }

    // Permissao que AINDA NAO FOI CADASTRADA nao barra ninguem.
    //
    // `registrados` e o catalogo do ambiente, nao a lista da pessoa. Sem essa
    // distincao, cadastrar a primeira permissao trancaria todas as telas de
    // uma vez: as rotas daqui ja declaram catorze codigos, e no instante em que
    // `codes` comeca a ser enviada os treze ainda nao cadastrados viram
    // negativa -- nao porque a pessoa nao pode, mas porque o codigo nao existe.
    //
    // Com o catalogo, cada permissao passa a valer quando e cadastrada. O
    // caminho deixa de ser um big-bang.
    if (Array.isArray(registrados) && !registrados.includes(codigo)) {
        return true;
    }

    return codigos.includes(codigo);
}

/** Verdadeiro se puder qualquer um da lista. Para no com varios filhos. */
export function podeAlgum(exigidos, codigos, registrados = null) {
    if (!Array.isArray(exigidos) || exigidos.length === 0) {
        return true;
    }

    return exigidos.some((codigo) => pode(codigo, codigos, registrados));
}

/**
 * Os codigos do usuario, ou `null` quando nao se sabe.
 *
 * `null` e o valor que faz o `pode` liberar. Devolver `[]` aqui num erro de
 * leitura trancaria a aplicacao inteira -- por isso a distincao e explicita e
 * o catch devolve null, nao array vazio.
 */
export function codigosDoUsuario() {
    try {
        const bruto = localStorage.getItem(CHAVE);
        if (!bruto) {
            return null;
        }

        const dados = JSON.parse(bruto);
        return Array.isArray(dados?.codes) ? dados.codes : null;
    } catch {
        return null;
    }
}

/**
 * Os codigos que EXISTEM no ambiente, ou `null` quando nao se sabe.
 *
 * Catalogo, nao permissao: diz o que ja foi cadastrado, para que uma permissao
 * ainda inexistente nao barre ninguem. `null` faz o `pode` conferir so contra
 * a lista da pessoa, que e o comportamento de antes.
 */
export function codigosRegistrados() {
    try {
        const bruto = localStorage.getItem(CHAVE);
        if (!bruto) {
            return null;
        }

        const dados = JSON.parse(bruto);
        return Array.isArray(dados?.codes_registrados)
            ? dados.codes_registrados
            : null;
    } catch {
        return null;
    }
}

/** Atalho para as telas: `podeAgora('accounts.grupos:editar')`. */
export function podeAgora(codigo) {
    return pode(codigo, codigosDoUsuario(), codigosRegistrados());
}
